module.exports = __webpack_public_path__ + "static/media/refunding.3a28f3f1.svg";